import React from 'react';
import { useDispatch } from 'react-redux';
import { Flex, Typography, message } from 'antd';
import { WarningFilled } from '@ant-design/icons';

import RegenerateTokenModal from './RegenerateTokenModal';
import { regenerateApiToken } from '../../../actions/prerenderUserActions';
import { useEvent } from '../../events/hooks/useEvent';
import { SETTINGS_UPDATED_FLAGS } from '../../events/settingsUpdatedEvent';
import ButtonWithRole from '../../../components/ButtonWithRole';
import { TOKEN_WRITE_REFUSED_ROLES } from '../../auth/roleCapabilities';

function RegenerateToken() {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useDispatch();
  const [messageApi, messageContext] = message.useMessage();
  const { track } = useEvent();

  const onCancel = () => {
    setModalVisible(false);
    setError(null);
  };

  const onConfirm = async () => {
    try {
      await regenerateApiToken(dispatch);
      setModalVisible(false);
      messageApi.success('Token regenerated successfully!');
      track('Settings Updated', { ...SETTINGS_UPDATED_FLAGS, token_is_updated: true });
    } catch (errorMsg) {
      setError(errorMsg);
    }
    setIsLoading(false);
  };

  return (
    <>
      {messageContext}
      <RegenerateTokenModal
        open={modalVisible}
        onCancel={onCancel}
        onConfirm={onConfirm}
        error={error}
        isLoading={isLoading}
      />
      <Flex vertical gap="large">
        <div>
          <Typography.Paragraph>
            <WarningFilled /> Warning! Generating a new token will invalidate the current one. If your site is already
            integrated with Prerender, doing so will break the integration until you replace the token in the
            authentication flow.
          </Typography.Paragraph>
          <Typography.Paragraph strong>
            Only use this if your current token is exposed and needs to be replaced.
          </Typography.Paragraph>
        </div>
        <Flex justify="center">
          <ButtonWithRole
            disabledFor={TOKEN_WRITE_REFUSED_ROLES}
            type="primary"
            danger
            onClick={() => setModalVisible(true)}
          >
            Generate New Token
          </ButtonWithRole>
        </Flex>
      </Flex>
    </>
  );
}

export default RegenerateToken;
